/*
 * todo: refactor listing actions
 * todo: add last find listings query context to make next and prev actions work
 * todo: fix more button style in listing specs
 */
/* eslint-disable */
import React, { useEffect, useMemo, useRef, useState } from "react";
import Router, { useRouter } from "next/router";
import Title from "../../Title";
import {
  CategoryList,
  CountersButtons,
} from "../../new-resolver/CountersButtons";
import BreadCrumb, { BreadCrumbHolder } from "../../new-resolver/breadCrumb";
import { useFindListing } from "../../new-resolver/useFindListings";
import css from "./.module.scss";
import ListingImages, { ListingImagesHolder } from "../ListingImages";
import { financialFormat } from "@/lib/helpers";
import { usePath } from "@/contexts/path/path";
import { Button, Modal } from "@aqar-app/react-ui";
import {
  useAuthState,
  useIsOwner,
  useIsOwnerByQuery,
} from "@/contexts/auth/auth.provider";
import dynamic from "next/dynamic";
import { AlertForUser, CLOSED_STATUS_MAP, SpaceAlert } from "./alert";
import ListingVideo from "./listingVideo";
import {
  trackCallUser,
  trackDisplayPaymentOptions,
  trackShowNumber,
  trackViewListing,
  trackWhatsappUser,
} from "@/lib/tracking/trackNavigationEvents";
import { useMutation, useQuery } from "@apollo/client";
import { INCREMENT_LISTING_ACTION } from "@/graphql/queries/listing";
import { ListingComments } from "@/components/Listing/comments";
import Link from "next/link";
import { OwnerControls } from "@/components/Listing/ListingScreen/ownerControls";
import { OwnerServices } from "@/components/Listing/ListingScreen/ownerServices";
import { RelatedListings } from "@/components/Listing/ListingScreen/relatedListings";
import { GET_MY_FOLLOW_LIST } from "@/graphql/queries/user";
import BiddingDetails, {
  StickyContainer,
} from "@/components/Listing/ListingScreen/bidding-section/BiddingDetails";
import { FINANCING_TEXTS } from "@/graphql/queries/info";
import {
  listingToEECItemObject,
  trackViewItem,
} from "@/lib/tracking/trackEECEvents";
import { Prices } from "@/components/Listing/ListingScreen/prices";
import LicenseExpiredAlert from "@/components/Listing/ListingScreen/LicenseExpiredAlert";
import Skeleton from "@/components/skeleton";
import RnplControls from "./RNPLControl";
import RnplSeekerControls from "./RNPLSeekerControl";
import SovControls from "./Promotion/sovControl";
import GoldenControls from "./Promotion/GoldenControls";
import Tooltip from "./Tooltip";

import { drawMarkerForSimpleListing } from "@/components/Listing/ListingScreen/DrawMarkerForSimpleListing";
import DistrictStats from "@/components/Listing/ListingScreen/DistrictStats/DistrictStats";
import { NewListingOwner } from "@/components/Listing/ListingScreen/owner/newListingOwner";
import { useAppState } from "@/contexts/app/app.provider";
import ReportButton from "@/components/Listing/ListingScreen/ListingControls/reportButton";
import { NewSpecsComponent } from "@/components/Listing/table/newSpecsComponent";
import { TabsSpecs } from "@/components/Listing/table/tabsSpecs";
import FavButton from "@/components/Listing/ListingScreen/ListingControls/favButton";
import ShareButton from "@/components/Listing/ListingScreen/ListingControls/shareButton";
import {
  NextListingButton,
  PreviousListingButton,
} from "@/components/Listing/ListingScreen/generalControls";
import useGetPhone from "@/components/Listing/ListingOwner/useGetPhone";
import Icon from "@/components/icon";
import LoginAlert, { NewSingleActionPopup } from "@/components/login-alert";
import config from "@/common/config";
import { ShowMore } from "@/components/Listing/showMore";
import { RandomAwarenessMessage } from "@/components/Listing/ListingScreen/awareness";
import { trackRequestFinancing } from "@/lib/tracking/trackRequestFinancing";
import { trackPromoScreenRedirection } from "@/lib/tracking/trackPromoScreenRedirection";
import LikeButton from "@/components/Listing/ListingScreen/ListingControls/LikeButton";
import useExpiredListings from "@/hooks/useExpiredListings";
import AdSpacesV2 from "@/components/Listing/ListingScreen/AdSpaceV2";
import { ClassicModal } from "@/components/Listing/ListingScreen/classicModal";
import { useListingStatusControl } from "@/hooks/useListingStatusControl";
import { trackAuctionListingBrochureClicked } from "@/lib/tracking/trackAuctionListingEvents";

const RNPL_CATEGORIES = [1, 4, 5, 13, 18, 19, 21, 22, 23];

function FixedBottomControls({ listing, frozenContext }) {
  const { user_id: id, status } = listing;
  const [phoneForCalls, setPhoneForCalls] = useState(null);
  const [incrementListingAction] = useMutation(INCREMENT_LISTING_ACTION);
  const path = usePath();
  const { getCallsPhone, getWhatsappPhone } = useGetPhone(listing);

  const isOwner = useIsOwner(listing);

  useEffect(() => {
    setPhoneForCalls(null);
  }, [listing]);
  const { token } = useAuthState();
  const whatsappButtonOnClick = async (e) => {
    if (!token) return Modal.open(<LoginAlert />)(e);

    trackWhatsappUser(path.previousPath);
    incrementListingAction({
      variables: { id: listing.id, type: "whatsapp" },
    });
    const phone = await getWhatsappPhone();
    if (!phone) return;
    if (phone.startsWith("http"))
      return window.open(phone, {
        target: "_blank",
      });
    return window.open(
      encodeURI(
        `${phone}?text=${`السلام عليكم\nأتواصل معك بخصوص إعلانكم على موقع عقار (${listing.title})\n${config.AQAR_WEB}/ad/${listing.id}`}`,
      ),
      {
        target: "_blank",
      },
    );
  };

  // eslint-disable-next-line consistent-return
  const phoneButtonOnClick = async (e) => {
    if (!token) return Modal.open(<LoginAlert />)(e);
    if (!phoneForCalls) {
      setPhoneForCalls(await getCallsPhone());
      trackShowNumber(path.previousPath);
    } else {
      incrementListingAction({
        variables: { id, type: "calls" },
      });

      trackCallUser(path.previousPath);

      window.open(`tel:${phoneForCalls}`, "_self");
    }
  };
  const { updateContext } = usePath();
  return (
    <div className={css.fixedMobileControlls}>
      <PreviousListingButton
        onListingChange={updateContext}
        frozenContext={frozenContext}
      />

      {isOwner ? (
        <div className={css.owner}>
          <button>إضافة إعلان</button>
        </div>
      ) : (
        <div className={css.btnSection}>
          {status !== 4 && (
            <button onClick={phoneButtonOnClick} className={css.callBtn}>
              <Icon name="Phone-white" width={14} height={14} />
              <span>{phoneForCalls ?? "إتصال"}</span>
            </button>
          )}
          <button onClick={whatsappButtonOnClick} className={`${css.whatsapp}`}>
            <Icon name="whatsapp-colored" width={14} height={14} />
            <span>واتساب</span>
          </button>
        </div>
      )}

      <NextListingButton
        frozenContext={frozenContext}
        onListingChange={updateContext}
      />
    </div>
  );
}

export function ListingScreenHolder() {
  return (
    <div>
      <CategoryList />
      <div className={css.root}>
        <BreadCrumbHolder />

        <Skeleton className={css.title}>
          <Skeleton.Item style={{ width: "15rem", height: "1.5rem" }} />
        </Skeleton>

        <ListingImagesHolder />
      </div>
    </div>
  );
}

const BiddersList = dynamic(
  () =>
    import("@/components/Listing/ListingScreen/bidding-section/BiddersList"),
  {
    ssr: false,
  },
);

const AwarenessNotification = dynamic(
  () => import("./awareness").then((m) => m.AwarenessMessage),
  {
    ssr: false,
  },
);
const SpacesModal = dynamic(
  () => import("./spacesModal").then((m) => m.SpacesModal),
  {
    ssr: false,
  },
);

const OpenInAppBtn = dynamic(
  () => import("./openInAppBtn").then((m) => m.OpenInAppBtn),
  {
    ssr: false,
  },
);
const LeafletMap = dynamic(() =>
  import("./LeafletMap").then((m) => m.LeafletMap),
);

const AdSpaces = dynamic(() => import("./AdSpaces").then((m) => m.AdSpaces), {
  ssr: false,
});
const AuctionPdfModal = dynamic(
  () => import("@/components/Listing/ListingScreen/AuctionPdfModal"),
  { ssr: false },
);

export function ClosedListing({ listing }) {
  return (
    <div>
      <CategoryList />
      <div className={css.root}>
        <Title />
        <BreadCrumb />
        <div className={css.title}>
          <h1>
            {listing.title} <span>مغلق</span>
          </h1>
        </div>
        <CountersButtons bottom />
        <RelatedListings listing={listing} />
      </div>
    </div>
  );
}

function MyFollowListLoader() {
  const token = useAuthState("token");
  useQuery(GET_MY_FOLLOW_LIST, {
    context: { token },
    skip: !token,
    onCompleted: (data) => {
      if (!data.User.listSearches) return;
      localStorage.setItem(
        "mySearches",
        JSON.stringify(
          data.User.listSearches.reduce(
            (acc, item) => ({
              ...acc,
              [`${item.category}${item.district_id}`]: item.expiration_time,
            }),
            {},
          ),
        ),
      );
    },
  });
  return null;
}
export const RENT_CATEGORIES = {
  1: 1,
  4: 1,
  5: 1,
  8: 1,
  11: 1,
  13: 1,
  14: 1,
  15: 1,
  16: 1,
  21: 1,
  18: 1,
  17: 1,
  19: 1,
  23: 1,
};

export function ListingPrice({ listing } = {}) {
  const { price, rent_period, category, is_auction } = listing;

  if (is_auction) {
    return null;
  }

  if (
    listing?.price_12_payments ||
    listing?.price_2_payments ||
    listing?.price_4_payments
  )
    return (
      <h2 className={css.price}>
        {financialFormat(price, "ريال")}
        {"/سنوي (دفعة واحدة)"}
      </h2>
    );

  if (rent_period + "" === "2") {
    return (
      <h2 className={css.price}>
        {financialFormat(price, "ريال")}
        {"/شهري"}
      </h2>
    );
  }

  if (RENT_CATEGORIES[category])
    return (
      <h2 className={css.price}>
        {financialFormat(price, "ريال")}
        {"/سنوي"}
      </h2>
    );
  return <h2 className={css.price}>{financialFormat(price, "ريال")}</h2>;
}

export function ListingPricingComponent({
  canViewContent,
  listing,
  path,
  pricesRef,
}) {
  const hasPrices =
    listing?.price_12_payments ||
    listing?.price_2_payments ||
    listing?.price_4_payments;

  const hasFinancing = listing?.title?.includes("للبيع");
  const biddable = listing?.biddable;

  const {
    data: {
      Info: {
        configurations: {
          generic_loan_application,
          financing_texts: financing,
        },
      },
    } = { Info: { configurations: {} } },
  } = useQuery(FINANCING_TEXTS);
  return (
    <>
      {canViewContent && !biddable && !listing?.is_auction ? (
        <div className={css.pricing}>
          <ListingPrice listing={listing} />

          {hasPrices ? (
            <button
              className={css.showPricesBtn}
              onClick={() => {
                trackDisplayPaymentOptions({
                  listingType: path?.listingType,
                  category: path?.category?.ga_property_category,
                  source: path?.previousPath || decodeURI(document.referrer),
                });

                pricesRef.current?.scrollIntoView();
              }}
            >
              عرض خيارات الدفع{" "}
              <svg
                width="11"
                height="10"
                viewBox="0 0 11 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.68038 9.85299C4.87621 10.049 5.20349 10.049 5.39987 9.85299L9.93103 5.33342C10.1294 5.13493 10.1294 4.81317 9.93103 4.6153C9.73259 4.4168 9.41042 4.4168 9.21199 4.6153L5.0399 8.77625L0.868344 4.6153C0.669415 4.4168 0.347708 4.4168 0.148778 4.6153C-0.0495928 4.81317 -0.0495928 5.13494 0.148778 5.33282L4.68038 9.85299Z"
                  fill="#4D4D4D"
                />
                <path
                  d="M4.68038 5.38668C4.87621 5.58269 5.20349 5.58269 5.39987 5.38668L9.93103 0.867114C10.1294 0.668619 10.1294 0.346861 9.93103 0.148987C9.73259 -0.0495086 9.41042 -0.0495086 9.21199 0.148987L5.0399 4.30994L0.868344 0.148987C0.669415 -0.0495086 0.347708 -0.0495086 0.148778 0.148987C-0.0495928 0.346861 -0.0495928 0.668633 0.148778 0.866508L4.68038 5.38668Z"
                  fill="#4D4D4D"
                />
              </svg>
            </button>
          ) : null}
        </div>
      ) : null}
      {hasFinancing ? (
        <div className={css.financing}>
          <p>{financing?.promotional_text?.ar}</p>
          <Link
            href={`/financing/${
              generic_loan_application === "MUNAASEB"
                ? "munaaseb"
                : "application"
            }?listingId=${listing.id}`}
          >
            <button
              type="button"
              onClick={() => {
                trackRequestFinancing({
                  source: path?.previousPath || decodeURI(document.referrer),
                });
              }}
            >
              {financing?.button_text?.ar}
            </button>
          </Link>
        </div>
      ) : null}
    </>
  );
}

function OwnerUi({ listing, isMobile } = {}) {
  const { token } = useAuthState();
  const { id, fullLoading, full } = listing;

  const openResumeSuccessModal = () => {
    Modal.open(
      <ClassicModal
        newDesign
        close={false}
        cancel={false}
        title="عقار"
        ok={{
          label: "حسنًا",
          cb: (e) => {
            Modal.close(e);
            router.reload();
          },
        }}
        body={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <p style={{ maxWidth: "356px", textAlign: "center" }}>
              تم إعادة نشر الإعلان بنجاح
            </p>
          </div>
        }
      />,
    )();
  };

  const { handleResumeListing, resumeLoading } = useListingStatusControl({
    token,
    onSuccess: () => {
      openResumeSuccessModal();
    },
    id: listing.id,
  });

  const active_monthly_listing_space_info =
    full?.active_monthly_listing_space_info;

  return (
    <div
      className={isMobile ? "" : css.sticky}
      style={{
        display: "grid",
        flex: "none",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      {fullLoading && (
        <Skeleton>
          <Skeleton.Item
            style={{
              borderRadius: ".5rem",
              width: "100%",
              height: "4.5rem",
            }}
          />
        </Skeleton>
      )}
      {active_monthly_listing_space_info && (
        <div className={css.active_space_info}>
          <Icon name="v1/calendar-clock-blue" />
          <div>
            <p>{active_monthly_listing_space_info.title_ar}</p>
            <p>{active_monthly_listing_space_info.text_ar}</p>
          </div>
        </div>
      )}
      {!fullLoading && listing.status === 5 && (
        <Button
          theme="info"
          disabled={resumeLoading}
          onClick={() => handleResumeListing({ id: listing.id })}
        >
          إعادة نشر الإعلان
        </Button>
      )}
      {listing.published ? (
        <>
          {!listing.premium && <GoldenControls id={id} isListingPage />}
          <SovControls
            id={id}
            sov_campaign_id={listing.sov_campaign_id}
            isListingPage
            listing={listing}
          />
          <OwnerServices listing={listing} />
        </>
      ) : null}
    </div>
  );
}

function AuctionDocumentButton({ listing } = {}) {
  const { previousPath, categoriesDictionary } = usePath();
  const { document_pdf: documentPdf, category } = listing;
  if (!documentPdf) return null;

  const clickHandler = (e) => {
    e.stopPropagation();
    // Use internal proxy endpoint to avoid CORS issues with react-pdf/pdf.js
    const src = `/api/auction-pdf?file=${encodeURIComponent(documentPdf)}`;
    Modal.open(<AuctionPdfModal src={src} original={documentPdf} />, {
      closeOnClickOutside: true,
    })();

    trackAuctionListingBrochureClicked({
      source: previousPath || decodeURI(document.referrer),
      listingType: categoriesDictionary?.[category]?.ga_listing_type,
      propertyCategory: categoriesDictionary?.[category]?.ga_property_category,
    })
  };

  return (
    <Button className={css.auctionDocumentButton} onClick={clickHandler}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.6 10.7002C2.78621 10.7002 0.5 9.29327 0.5 9.29327V1.20361C0.5 1.20361 3.13793 1.90706 5.6 1.90706V10.7002ZM5.6 10.7002C8.41379 10.7002 10.7 9.29327 10.7 9.29327V1.20361"
          stroke="#3677F5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.59961 1.9069C7.35823 1.9069 8.58926 0.5 8.58926 0.5V9.11724C8.58926 9.11724 7.35823 10.5241 5.59961 10.5241"
          stroke="#3677F5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span>استعراض ملف المزاد</span>
    </Button>
  );
}

export default function ListingScreen({ frozenContext } = {}) {
  const router = useRouter();
  const [listing] = useFindListing();
  const {
    price,
    imgs,
    title,
    category,
    status,
    published,
    id,
    biddable,
    rnpl_monthly_price,
    precise_location_request_status,
    is_auction,
  } = listing;

  let isOpen = !CLOSED_STATUS_MAP[status];
  const isPaused = status === 5;
  const isLicenseExpired = status === 10;

  const { user } = useAuthState();
  const { isMobile: mobile } = useAppState();
  const lastIdRef = useRef(0);
  const [incrementListingAction] = useMutation(INCREMENT_LISTING_ACTION);

  const [bidMode, setBidMode] = useState("off");
  const [listingBidId, setListingBidId] = useState(null);

  // const [isDistrictStatsNearVisible, setIsDistrictStatsNearVisible] =
  //   useState(false);
  // const districtStatsObservableRef = useRef(null);
  const [isMobile, setIsMobile] = useState(mobile);

  useEffect(() => {
    if (window.innerWidth < 700) setIsMobile(true);
    else setIsMobile(false);
  }, []);

  useEffect(() => {
    function ls(event) {
      if (window.innerWidth < 768) setIsMobile(true);
      else setIsMobile(false);
    }

    window.addEventListener("resize", ls);

    return () => window.removeEventListener("resize", ls);
  }, []);

  useEffect(() => {
    if (router.query?.from === "rega") {
      setTimeout(() => {
        Modal.open(
          <NewSingleActionPopup
            text="تم نشر الإعلان بنجاح"
            onOk={() => {
              const query = { ...router.query };
              delete query.from;
              router.replace(
                {
                  pathname: router.pathname,
                  query,
                },
                undefined,
                { shallow: true },
              );
              Modal.close();
              trackPromoScreenRedirection({ listingType: path?.listingType });
              router.push(
                `/user/promotion?id=${listing.id}&listing_type=${path?.listingType}&category=${path?.category?.ga_property_category}&allowback=true`,
              );
            }}
          />,
        )();
      }, 0);
    }
  }, [router.query]);

  const isOwnerPublic = useIsOwner(listing);
  const {
    isOwner: isOwnerAuth,
    loading: isOwnerLoading,
    ownerListing,
  } = useIsOwnerByQuery(listing?.id, !isPaused);
  const isOwner = isOwnerPublic || isOwnerAuth;

  const canViewContent = isOwner || published || user?.paid;
  const showContactDetails =
    (status === 4 && !isOwner) ||
    (!listing.hide_contact_details && !isOwner && (published || user?.paid));

  const {
    fields,
    extendedFields,
    updateContext,
    categoriesDictionary,
    ...path
  } = usePath();

  const spaceModalRef = useRef({});

  const { listings: expiredListings, loading: loadingExpiredLicense } =
    useExpiredListings({
      enabled: isLicenseExpired,
    });

  const isUserExpiredListing = useMemo(() => {
    if (!user || !expiredListings || !isLicenseExpired) return false;
    return expiredListings.some((listing) => listing.id === path?.listing?.id);
  }, [user, expiredListings, path?.listing?.id]);

  const pricesRef = useRef(null);
  useEffect(() => {
    const { listing, category, city, district } = path;

    if (
      !category ||
      !district ||
      path.resolving ||
      lastIdRef.current === path.listing?.id
    )
      return;
    lastIdRef.current = path.listing.id;
    incrementListingAction({ variables: { id: listing.id, type: "views" } });
    trackViewListing({
      ...listing,
      category,
      district: district.name,
      city: city.name,
    });
  }, [path]);

  useEffect(() => {
    if (spaceModalRef.current[listing?.id]) return;

    if (!user || !listing) return;
    const space = listing.full?.new_listing_space_fees;
    if (!space?.popup) return;
    setTimeout(() => {
      Modal.open(<SpacesModal space={space} />, {
        escape: false,
      })();
    }, 20);
    spaceModalRef.current = { ...spaceModalRef.current, [listing.id]: true };
  }, [listing]);

  const handleRouteChangeComplete = () => {
    const hash = Router.asPath.split("#")?.[1] || "off";
    setBidMode(hash);
  };

  useEffect(() => {
    // const observer = new IntersectionObserver(
    //   (entries) => {
    //     if (entries[0].isIntersecting) {
    //       setIsDistrictStatsNearVisible(true);
    //       observer.disconnect();
    //     }
    //   },
    //   { threshold: 0.1 },
    // );
    //
    // if (districtStatsObservableRef.current) {
    //   observer.observe(districtStatsObservableRef.current);
    // }

    // Provided UX does not offer any way for the users to opt out the bidding screen. So we rely on routing with hash to do so.
    Router.events.on("hashChangeComplete", handleRouteChangeComplete);

    return () => {
      Router.events.off("hashChangeComplete", handleRouteChangeComplete);
      // if (districtStatsObservableRef.current) {
      //   observer.unobserve(districtStatsObservableRef.current);
      // }
    };
  }, []);

  useEffect(() => {
    trackViewItem(
      listingToEECItemObject(listing, undefined, categoriesDictionary),
      { value: price },
    );
  }, [listing.id]);

  if (!isOwnerPublic && isPaused && isOwnerLoading) {
    return null;
  }

  if (isOwner && isPaused) {
    isOpen = true;
  }

  const fullListing = isOwner
    ? { ...listing, ...ownerListing } || listing
    : listing;

  if (
    !isOpen ||
    (isLicenseExpired && !isOwnerPublic && !isUserExpiredListing)
  ) {
    return <ClosedListing listing={listing} />;
  }

  return (
    <div className="white">
      <CategoryList />
      <div className={css.root}>
        <Title />
        <BreadCrumb />
        {bidMode === "off" && (
          <>
            <div className={css.title}>
              <h1>{title}</h1>
            </div>
            <div className={css.images}>
              <div className={css.controls}>
                {!isOwner && <LikeButton listing={fullListing} />}
                <FavButton listing={fullListing} />
                <ShareButton type="listing" listing={fullListing} />
                {isOwner ? <OwnerControls listing={fullListing} /> : null}
              </div>
              {isOpen && fullListing?.imgs?.length ? (
                <ListingImages
                  listing={fullListing}
                  loaded={fullListing.loadedImage}
                />
              ) : null}
            </div>

            {/*<div ref={districtStatsObservableRef} />*/}

            <div className={css.towColumns}>
              <div>
                <div className={css.categoryRow}>
                  {!!path?.category && (
                    <div className={css.auction}>
                      {is_auction && (
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.04024 12.0766H7.70628L7.67673 11.9956C7.43584 11.3501 6.81817 10.9227 6.12661 10.9242H2.62738C1.93729 10.9242 1.31961 11.3516 1.07875 11.9971L1.04771 12.0781H0.701932C0.314773 12.0781 2.07811e-05 12.392 2.07811e-05 12.7781V13.207C-0.00293755 13.5931 0.310336 13.9085 0.697495 13.9099H0.701932L8.04024 13.9055C8.42738 13.9055 8.74215 13.5916 8.74215 13.2055V12.7767C8.74215 12.3905 8.42738 12.0766 8.04024 12.0766ZM13.555 11.3383L9.13669 6.60772C9.59331 6.18919 10.0041 5.72202 10.3602 5.21507C10.6735 5.35359 11.037 5.31233 11.3119 5.10748C11.7316 4.79506 11.8173 4.20116 11.504 3.78262L8.94902 0.379831C8.74363 0.104248 8.40523 -0.0372218 8.06387 0.00846275C7.54371 0.0762475 7.17872 0.552261 7.24817 1.071C5.51186 1.65164 4.00905 2.77314 2.95987 4.26894C2.64512 4.13042 2.2816 4.17168 2.00822 4.37653C1.58708 4.68896 1.50137 5.28286 1.81612 5.70139L4.36812 9.10418C4.57502 9.38271 4.91782 9.52566 5.26214 9.4785C5.78082 9.40628 6.14285 8.9288 6.07192 8.41007C6.65857 8.21406 7.22454 7.95321 7.75503 7.63489L11.0577 13.2026C11.1242 13.319 11.2055 13.428 11.3001 13.5238C11.9044 14.1457 12.9004 14.1605 13.5225 13.5562C14.1461 12.952 14.1609 11.9602 13.555 11.3383Z"
                            fill="#4D4D4D"
                          />
                        </svg>
                      )}
                      <h2 className={css.category}>
                        {is_auction ? "مزاد: " : ""}
                        {path?.category?.name}
                      </h2>
                    </div>
                  )}
                  {precise_location_request_status === "approved" && (
                    <Tooltip content="تم التحقق من دقة موقع العقار ">
                      <div className={css.approvedPreciseLocation}>
                        <svg
                          width="10"
                          height="12"
                          viewBox="0 0 10 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 5.09185C10 5.55757 9.90885 6.04657 9.72656 6.55886C9.54427 7.07115 9.27865 7.60414 8.92969 8.15783C8.58073 8.71151 8.14583 9.28331 7.625 9.87322C7.10417 10.4631 6.50521 11.0686 5.82812 11.6895C5.71354 11.793 5.58333 11.8706 5.4375 11.9224C5.29167 11.9741 5.14583 12 5 12C4.85417 12 4.70833 11.9741 4.5625 11.9224C4.41667 11.8706 4.28646 11.793 4.17188 11.6895C3.49479 11.0686 2.89583 10.4631 2.375 9.87322C1.85417 9.28331 1.41927 8.71151 1.07031 8.15783C0.721354 7.60414 0.455729 7.07115 0.273438 6.55886C0.0911458 6.04657 0 5.55757 0 5.09185C0 3.53946 0.502604 2.30272 1.50781 1.38163C2.51302 0.460543 3.67708 0 5 0C6.32292 0 7.48698 0.460543 8.49219 1.38163C9.4974 2.30272 10 3.53946 10 5.09185Z"
                            fill="white"
                          />
                          <path
                            d="M4.25635 5.85246L3.74921 5.31621C3.60431 5.163 3.43527 5.08639 3.24207 5.08639C3.04887 5.08639 2.87982 5.163 2.73492 5.31621C2.59003 5.46942 2.51758 5.65136 2.51758 5.86203C2.51758 6.0727 2.59003 6.25464 2.73492 6.40786L3.74921 7.4995C3.89411 7.65272 4.06316 7.72932 4.25635 7.72932C4.44955 7.72932 4.6186 7.65272 4.7635 7.4995L7.33544 4.77996C7.48034 4.62675 7.55279 4.44481 7.55279 4.23414C7.55279 4.02347 7.48034 3.84153 7.33544 3.68832C7.19054 3.5351 7.01847 3.4585 6.81924 3.4585C6.62 3.4585 6.44794 3.5351 6.30304 3.68832L4.25635 5.85246Z"
                            fill="#52B44A"
                          />
                        </svg>
                        <span>موقع دقيق</span>
                      </div>
                    </Tooltip>
                  )}
                </div>
                {isMobile && is_auction && (
                  <AuctionDocumentButton listing={fullListing} />
                )}
                <ListingPricingComponent
                  canViewContent={canViewContent}
                  listing={fullListing}
                  path={path}
                  pricesRef={pricesRef}
                />
                {isUserExpiredListing && (
                  <LicenseExpiredAlert listing={fullListing} />
                )}

                {isOwner && (
                  <SpaceAlert
                    space={fullListing?.full?.new_listing_space_fees}
                    alert={fullListing.alert_box}
                    listing={fullListing}
                  />
                )}
                {!published && (
                  <AlertForUser
                    user={user}
                    alert_box={fullListing.alert_box}
                    listingUserId={fullListing.user_id}
                  />
                )}
                {!isOwner &&
                RNPL_CATEGORIES?.includes(category) &&
                published &&
                rnpl_monthly_price ? (
                  <RnplSeekerControls
                    rnpl_monthly_price={rnpl_monthly_price}
                    id={id}
                    price={price}
                  />
                ) : null}
                {isOwner && isMobile && (
                  <OwnerUi isMobile={isMobile} listing={fullListing} />
                )}
                <DistrictStats listing={fullListing} />
                {fullListing.content && canViewContent && !biddable ? (
                  <div
                    className={`${css.card} ${css.bottomBorderOnly} ${css.flex}`}
                  >
                    <ShowMore lines={2}>{fullListing.content}</ShowMore>
                  </div>
                ) : null}
                <NewSpecsComponent
                  fields={fields}
                  extendedFields={extendedFields}
                  listing={fullListing}
                />

                {fullListing.extended_details?.guarantees_and_their_duration ? (
                  <div>
                    <div className={css.title}>الضمانات ومدتها</div>
                    <div className={`${css.card} ${css.flex}`}>
                      <p className={css.content}>
                        {
                          fullListing.extended_details
                            .guarantees_and_their_duration
                        }
                      </p>
                    </div>
                  </div>
                ) : null}

                {biddable && (
                  <BiddingDetails
                    listingId={id}
                    isListingOwner={isOwner}
                    bidMode={bidMode}
                    setBidMode={setBidMode}
                    setListingBidId={setListingBidId}
                  />
                )}

                {fullListing.videos?.length && (
                  <>
                    <h3>الفيديوهات</h3>
                    <div className={css.videosWrapper}>
                      {!!fullListing?.has_video &&
                        fullListing.videos.map((v) => (
                          <div key={v.video}>
                            {" "}
                            <ListingVideo videoItem={v} />
                          </div>
                        ))}
                    </div>
                  </>
                )}

                {/*<AdSpaces id={listing?.id} />*/}
                <AdSpacesV2
                  listingId={fullListing?.id}
                  adTypes={[isMobile ? "space_3" : "wide_space_3"]}
                />

                <h4>الموقع</h4>

                {canViewContent && (
                  <LeafletMap
                    onMapReady={drawMarkerForSimpleListing(fullListing)}
                    trackPdpMapEvent
                    className={css.mapWrapper}
                  />
                )}
                <OpenInAppBtn listingId={fullListing?.id} />
                {!!fullListing?.extended_details
                  ?.location_description_on_moj_deed && (
                  <>
                    <AwarenessNotification
                      message={
                        <>
                          <span className={css.bold}>
                            نأمل مطابقة الموقع على الخريطة مع الموقع حسب الصك
                          </span>
                          :{" "}
                          {
                            fullListing?.extended_details
                              ?.location_description_on_moj_deed
                          }
                        </>
                      }
                    ></AwarenessNotification>
                  </>
                )}
                {!isMobile ? null : (
                  <>
                    {showContactDetails && (
                      <div className={css.ownerWrapper}>
                        <h4>معلومات المعلن</h4>
                        <div className={css.card}>
                          <NewListingOwner listing={fullListing} />
                        </div>
                        <RandomAwarenessMessage
                          listingId={fullListing.id}
                          className={css.awarness}
                        />
                        <ReportButton
                          className={css.reportButton}
                          listingID={fullListing.id}
                        />
                      </div>
                    )}
                  </>
                )}
                <Prices listing={fullListing} ref={pricesRef} />

                <ListingComments listing={fullListing} />

                <TabsSpecs listing={fullListing} />
                {isMobile ? null : (
                  <div className={css.changeControlls}>
                    <PreviousListingButton
                      onListingChange={updateContext}
                      frozenContext={frozenContext}
                    >
                      الإعلان السابق
                    </PreviousListingButton>
                    <NextListingButton
                      onListingChange={updateContext}
                      frozenContext={frozenContext}
                    >
                      الإعلان التالي
                    </NextListingButton>
                  </div>
                )}
                <MyFollowListLoader />
                {bidMode === "bid" && (
                  <BiddingDetails
                    listingId={id}
                    isListingOwner={isOwner}
                    bidMode={bidMode}
                    setBidMode={setBidMode}
                    setListingBidId={setListingBidId}
                  />
                )}
                {bidMode === "bidders" && (
                  <BiddersList listingBidId={listingBidId} />
                )}
              </div>

              {isMobile ? null : (
                <>
                  {showContactDetails && (
                    <StickyContainer className={css.sticky}>
                      <div className={css.ownerWrapper}>
                        <h4>معلومات المعلن</h4>
                        <div className={css.card}>
                          <NewListingOwner listing={fullListing} />
                        </div>
                        <AuctionDocumentButton listing={fullListing} />
                        <RandomAwarenessMessage
                          listingId={fullListing.id}
                          className={css.awarness}
                        />
                        <ReportButton
                          className={css.reportButton}
                          listingID={fullListing.id}
                        />
                      </div>
                    </StickyContainer>
                  )}
                </>
              )}
              {isOwner && !isMobile && (
                <OwnerUi isMobile={isMobile} listing={fullListing} />
              )}
            </div>
          </>
        )}
        <CountersButtons bottom />

        <RelatedListings listing={fullListing} />
        {isMobile ? (
          <FixedBottomControls
            frozenContext={frozenContext}
            listing={fullListing}
          />
        ) : null}
      </div>
    </div>
  );
}
